/**
 * BookableResourceStatusService
 * Service for managing bookable resource statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for bookable resource status CRUD operations
 */
export class BookableResourceStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookableResourceStatusService.DEFAULT_SERVICE_PATH,
            basePath: BookableResourceStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BookableResourceStatusService.DEFAULT_SERVICE_PATH = 'booking-management';
BookableResourceStatusService.BASE_PATH = 'api/bookable-resource-statuses';
//# sourceMappingURL=BookableResourceStatusService.js.map